import React from 'react';
import classnames from '../../helpers/classnames';
import {ColorIconProps} from '../../@types/components/ColorIcon';

export default function ColorIcon<Element extends HTMLElement = HTMLSpanElement>(props: ColorIconProps<Element>) {
    const {color, tag, className, style, ...rest} = props;

    const Tag = tag ?? 'i';

    return <Tag
            {...rest}
            className={classnames(className, 'color-icon')}
            style={{
                ...(style ?? {}),
                background: color || 'transparent'
            }}
    />;
}

